import { useQuery } from 'react-query';

import { QueryEntity } from '../../types';
import { SeatBasedUsageResponse } from '../../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

// organisationId/userId are only honoured for platform usage operators viewing another org's user.
export const useFetchSeatBasedUsage = (enabled: boolean = true, organisationId?: string, userId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<SeatBasedUsageResponse | null>(
    [QueryEntity.SeatBasedUsage, { organisationId, userId }],
    async () => {
      const url = new URL(`${APIBaseChronos}/api/usage/seat-usage`);
      if (organisationId) url.searchParams.append('organisationId', organisationId);
      if (userId) url.searchParams.append('userId', userId);
      const res = await fetch(url.toString(), fetchConfigGET);
      if (!res.ok) throw new Error('Failed to fetch seat-based usage');
      return await res.json();
    },
    { enabled, refetchOnWindowFocus: false },
  );
};
